import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'

export const useBomItemMenuStyles = makeStyles()((theme: Theme) => ({
  menuRoot: {
    maxWidth: `${theme.breakpoints.values['sm']}px`,
    whiteSpace: 'normal',
    width: '100%',
    padding: theme.spacing(1, 2),
  },
  menuItemAvatar: {
    color: theme.palette.text.secondary,
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      width: `${theme.spacing(3)} !important`,
      height: `${theme.spacing(3)} !important`,
    },
  },
}))
